import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.kissorder').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.kissorder', {
                abstract: true,
                component: 'contentLayout'
            })
            .state('app.kissorder.list', {
                url: '/kiss-order/list',
                views: {
                    content: {
                        component: 'listKissOrders'
                    }
                },
                data: {
                    authorizedRole: 'SUPPORT'
                }
            })
            .state('app.kissorder.detail_tabs', {
                url: '/kiss-order/detail/{guid}',
                views: {
                    content: {
                        component: 'orderDetailTabs'
                    }
                },
                params: {
                    guid: null,
                    order: null
                },
                resolve: {
                    order: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().order;
                        }
                    ],
                    guid: [
                        '$transition$',
                        function($transition$) {
                            return $transition$.params().guid;
                        }
                    ]
                },
                data: {
                    authorizedRole: 'SUPPORT'
                }
            });
    }
})();
